/**
 * View Password
 * 
 * @module view-password
 * @version 1.0.0
 * @extends HTMLElement
*/

customElements.component = 'view-password';

if (!customElements.get(customElements.component)) {

    class viewPassword extends HTMLElement {

        constructor() {

            super();

            this.initEvents();
        }

        /**
         * Init events
         * 
         * @return {undefined}
         */
         initEvents() {
            let button =  this.querySelector("[data-view]");

            button.addEventListener('click', () => {
                if(button.classList.contains("active")) {
                    button.classList.remove("active");
                    this.querySelector("input").setAttribute("type", "password");
                } else {
                    button.classList.add("active");
                    this.querySelector("input").setAttribute("type", "text");
                }
            });
        }

    }

    customElements.define(customElements.component, viewPassword);
}
